/**
 * js时间格式化
 * 暂时只用于route管理下返回的13位时间戳 
 * month+1
 * 之后可以封装一个Date.prototype.Format()方法
 * @param {*} value 
 */

export function dateFormat(value) {
    let date = new Date(value);
    if (value === null) {
        return ''
    }
    if (date.toString() === 'Invalid Date') {
        return ''
    }
    return `${date.getFullYear()}-${dateFormatHelper(date.getMonth() + 1)}-${dateFormatHelper(date.getDate())} ${dateFormatHelper(date.getHours())}:${dateFormatHelper(date.getMinutes())}`
}

export function dateFormatTemp(value) {
    let date = new Date(value);
    if (value === null) {
        return ''
    }
    if (date.toString() === 'Invalid Date') {
        return ''
    }
    return `${date.getFullYear()}-${dateFormatHelper(date.getMonth() + 1)}-${dateFormatHelper(date.getDate())}`
}

function dateFormatHelper(value) {
    return value.toString().padStart(2, '0')
}
/**
 * 数值格式化
 * 将数字转为EN-US，千分制分隔
 * 失败返回 ''
 * @param {*} value 
 */
export function numberFormat(value) {
    let number = +value;
    if (isNaN(number)) {
        return ''
    } else {
        let reg = /(?=(\B\d{3})+$)/g;
        return number.toString().replace(reg, ',');
    }
}
/**
 * 状态格式化1（0正常 1禁用 2已删除）
 * 失败返回 ''
 * @param {*} value 
 */
export function statusFormat(value) {
    let statusOptions = {
        '0': '正常',
        '1': '禁用',
        '2': '已删除'
    };
    return typeof(statusOptions[value]) === 'undefined' ? '' : statusOptions[value]

}

/**
 * 状态格式化2（0暂未开始 1正在进行 2已经结束 3异常）
 * 失败返回 ''
 * @param {*} value 
 */
export function status2Format(value) {
    if ((typeof(value) === 'number' || typeof(value) === 'string') && value.toString().length === 1) {
        let statusOptions = {
            '0': '正常',
            '1': '禁用',
            '2': '已在行程中',
            '3': '异常'
        };
        return typeof(statusOptions[value]) === 'undefined' ? '' : statusOptions[value]
    }
    return ''
}

/**
 * 状态类型格式化2（0 success 1 warning 2 danger 3 info other ''）
 * 失败返回 ''
 * @param {*} value 
 */
export function statusTypeFormat(value) {
    if ((typeof(value) === 'number' || typeof(value) === 'string') && value.toString().length === 1) {
        let statusTypeOptions = {
            '0': 'success',
            '1': 'warning',
            '2': 'danger',
            '3': 'info'
        };
        return typeof(statusTypeOptions[value]) === 'undefined' ? '' : statusTypeOptions[value]
    }
    return ''
}

/**
 * 人数格式化 1 --> 1人
 * 失败返回 ''
 * @param {*} value 
 */
export function peopleFormat(value) {
    if ((typeof(value) === 'number' || typeof(value) === 'string')) {

        return `${value}人`
    }
    return ''
}

/**
 * 操作-->修改状态
 * @param {*} action 
 */
export function actionFormat(action) {
    if (!action) return ''
    const actionMap = new Map();
    actionMap.set("enable", 0);
    actionMap.set("disable", 1);
    actionMap.set("delete", -1);
    return actionMap.get(action);
}



/**
 * options [{key,val}]
 * 返回val 或 ''
 * @param {*} key 
 * @param {*} options 
 */
export function keyToVal(key, options) {
    if (typeof(key) == 'undefined' || key === null || !Array.isArray(options)) {
        return ''
    }
    for (let i of options) {
        if (i.key == key) return i.val
    }
    return ''
}
// const typeMap = new Map()
// typeMap.set("ROOT", "根节点");
// typeMap.set("MENU-1", "一级菜单");
// typeMap.set("MENU-2", "二级菜单");
// typeMap.set("PAGE", "页面")
// typeMap.set("BUTTON", "按钮")

// export  {
//     typeMap
// }
// export function menuTypeFormat(type) {
//     if (!type) return ''

// }